function fetchUser(id, apiUrl, token) {
  return fetch("".concat(apiUrl, "/v1/users/").concat(id), {
    method: 'GET',
    headers: {
      Authorization: "Bearer ".concat(token)
    }
  }).then(function (res) {
    if (!res.ok) throw Error(res.statusText);
    return res.json();
  });
}

export default fetchUser;